import { Box, Link as MuiLink, Stack, Typography } from "@mui/material";
import { SetupStepIndicator } from "Components/Dashboard/SetupChecklist/SetupStepIndicator";
import type { SetupStepRowState } from "Components/Dashboard/SetupChecklist/types";
import { ButtonLink } from "Components/Shared/ButtonLink";
import { Link } from "Navigation/Link";
import type { ReactNode } from "react";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.SetupChecklist;

type Props = {
  state: SetupStepRowState;
  stepNumber: number;
  title: string;
  description: ReactNode;
  ctaText: string;
  ctaUrl: string;
  isUpcomingLinkHidden?: boolean;
};

export const SetupChecklistRow = ({
  state,
  stepNumber,
  title,
  description,
  ctaText,
  ctaUrl,
  isUpcomingLinkHidden = false,
}: Props) => {
  const { t } = useResource();
  const isMuted = state === "done" || state === "inReview";

  return (
    <Stack gap={2} py={3}>
      <Box display="flex" alignItems="center" gap={2}>
        <SetupStepIndicator state={state} stepNumber={stepNumber} />
        <Typography
          fontWeight={isMuted ? 400 : 600}
          color={isMuted ? "text.disabled" : "text.primary"}
          flexGrow={1}
        >
          {title}
        </Typography>
        {state === "inReview" && (
          <Typography color="text.secondary">
            {t(RESOURCES.InReview)}
          </Typography>
        )}
        {state === "upcoming" && !isUpcomingLinkHidden && (
          <MuiLink
            component={Link}
            to={ctaUrl}
            fontWeight={600}
            underline="none"
          >
            {t(RESOURCES.Start)}
          </MuiLink>
        )}
      </Box>
      {(state === "active" || state === "blocked") && (
        <Typography color="text.secondary">{description}</Typography>
      )}
      {state === "active" && (
        <ButtonLink
          color="primary"
          variant="contained"
          fullWidth
          link={ctaUrl}
          text={ctaText}
        />
      )}
    </Stack>
  );
};
